import React from 'react';
import { View, Text } from 'react-native-web';

export function NotFound() {
    return(
        <View style={{ width: '100%', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            <Text style={{ color: 'gray', fontSize: 20, fontWeight: 'bold' }}>
                Oops, this page is 404
            </Text>
        </View>
    );
}
